module.exports = __webpack_public_path__ + "img/nordrhein-westfalen.7061d64.webp";